const getFirstCorrectData = (firstData, secondData, thirdData) => {
    if (firstData !== undefined && firstData !== null) return firstData;
    if (secondData !== undefined && secondData !== null) return secondData;
    return thirdData;
};

export default getFirstCorrectData;
